import { Button } from '@platform/ui';
import { Link } from '@tanstack/react-router';

import { useMessages } from '../i18n';
import { useCanOpen } from '../lib/session';

/**
 * A subscription that needs paying, said on every page and to everyone in the
 * company (ADR 0016): Ödeme Bekliyor while nothing is restricted yet, and
 * Süresi Doldu once the account operates safely — orders keep moving, what
 * grows the account waits (ADR 0017 §4). The way to pay is offered to who may
 * open the subscription.
 */
export function SubscriptionBanner({ status }: { status: 'past_due' | 'expired' }) {
    const t = useMessages();
    const canOpen = useCanOpen();
    const expired = status === 'expired';

    return (
        <div
            role={expired ? 'alert' : 'status'}
            className={
                expired
                    ? 'flex flex-wrap items-center justify-center gap-3 border-b-2 border-destructive bg-destructive-subtle px-4 py-2 text-13 font-medium text-foreground'
                    : 'flex flex-wrap items-center justify-center gap-3 border-b border-border bg-warning-subtle px-4 py-2 text-13 text-foreground'
            }
        >
            <span>{expired ? t.subscription.banner.expired : t.subscription.banner.pastDue}</span>
            {canOpen('/abonelik') && (
                <Button asChild size="sm" variant="secondary">
                    <Link to="/abonelik">{t.subscription.banner.action}</Link>
                </Button>
            )}
        </div>
    );
}
